import AOS from 'aos';
import initializeMobileMenu from './menu';
import initializeCollapse from './blocks/collapse';
import initializeFancyBox from './fancybox';
import initializeForm from './utils/form';
import initializeSearch from './blocks/search';
import initializeMap from './blocks/find-place';
import initializeModals from "./utils/modals";
import WooCommerce from "./woo";
import initializeSelects from "./woo/selects";
import './utils/scrollup';

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        AOS.init({
            startEvent: 'load',
            disable: 'mobile',
            once: true,
            duration: 300
        });
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeCollapse();
        initializeSearch();
        initializeModals();
        initializeMap();
        initializeSelects();

        new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
